<template>
  <q-card-section class="tm-card-section">
    <slot />
  </q-card-section>
</template>
